/* eslint-disable promise/catch-or-return */
import shippingCalculatorService from 'tradera-apps/syi/script/app_react/services/shipping-calculator-service';
import { getShippingProviders } from 'tradera-apps/syi/script/app_react/services/shipping-provider-service';
import {
    getPrimaryOrSecondaryProducts,
    getVariant
} from '../reducers/shipping/shipping-selectors';
import { getSyiSlice } from 'tradera-state/views/syi/selectors/syi';
import { transformPostNordParcelProductId } from './helpers/postnord-parcel-productid-converter-helper';

const reset = () => ({
    type: 'RESET_SHIPPING_OPTIONS'
});

const resetSelected = () => ({
    type: 'RESET_SELECTED_SHIPPING_OPTIONS'
});

const toggleShippingOption = (type, primary) => dispatch => {
    dispatch({
        type: 'TOGGLE_SHIPPING_OPTION',
        payload: {
            type,
            primary
        }
    });
};

const setShippingOptionCost = (cost, primary) => ({
    type: 'SET_SHIPPING_OPTION_COST',
    payload: {
        cost,
        primary
    }
});

const setShippingOptionVariant = (primary, variant) => dispatch => {
    dispatch({
        type: 'SET_SHIPPING_OPTION_VARIANT',
        payload: {
            primary,
            variant
        }
    });
};

const setOfferTakeaway = offerTakeaway => ({
    type: 'SET_TAKEAWAY_SELECTED',
    payload: {
        offerTakeaway
    }
});

const setOfferShipping = offerShipping => ({
    type: 'SET_SHIPPING_SELECTED',
    payload: {
        offerShipping
    }
});

const setSecondaryShippingOptionOpen = open => ({
    type: 'SET_SECONDARY_SHIPPING_OPTION_OPEN',
    payload: { secondaryShippingOptionOpen: open }
});

const removeShippingOption = primary => ({
    type: 'REMOVE_SHIPPING_OPTION',
    payload: {
        primary: primary
    }
});

const makeSecondaryShippingOptionPrimary = () => ({
    type: 'MAKE_SECONDARY_SHIPPING_OPTION_PRIMARY'
});

const clearSuggestedShippingProducts = primary => dispatch => {
    dispatch({
        type: 'CLEAR_SUGGESTED_SHIPPING_PRODUCTS',
        payload: { primary }
    });
};

const setSuggestedShippingProducts = (
    shippingProducts,
    primary
) => dispatch => {
    dispatch({
        type: 'SET_SUGGESTED_SHIPPING_PRODUCTS',
        payload: { shippingProducts, primary }
    });
};

const calculateShipping = (
    length,
    width,
    height,
    weight,
    primary
) => dispatch => {
    shippingCalculatorService
        .calculateShipping(length, width, height, weight)
        .then(data => {
            var shippingProducts = [];
            for (var i = 0; i < data.shippingOptions.length; i++) {
                let providerName = data.shippingOptions[i].providerName;
                let additionalInfo = null;

                if (providerName === 'Bussgods' && weight > 35000) {
                    additionalInfo =
                        'OBS! Varje kolli får väga max 35 kg. Du kan skicka flera kollin i samma sändning.';
                }

                shippingProducts.push({
                    type: providerName,
                    cost: data.shippingOptions[i].price,
                    description: data.shippingOptions[i].description,
                    additionalInfo: additionalInfo
                });
            }
            dispatch(setSuggestedShippingProducts(shippingProducts, primary));
            return data;
        });
};

const toggleShippingCalculator = primary => (dispatch, getState) => {
    const currentValue = getSyiSlice(getState()).shipping[
        primary
            ? 'showPrimaryShippingCalculator'
            : 'showSecondaryShippingCalculator'
    ];
    dispatch({
        type: 'SET_SHOW_SHIPPING_CALCULATOR',
        payload: { value: !currentValue, primary }
    });
};

const setCalculatorDimensions = (dimensions, primary) => dispatch => {
    dispatch({
        type: 'SET_SHIPPING_CALCULATOR_DIMENSIONS',
        payload: { dimensions, primary }
    });
};

const setShippingOptionsFromDraft = (shippingOptions = []) => async (
    dispatch,
    getState
) => {
    if (
        shippingOptions.some(
            shippingOption =>
                shippingOption.type === 'Takeaway' ||
                shippingOption.type === 'TakeawayOnly'
        )
    ) {
        dispatch(setOfferTakeaway(true));
    } else {
        dispatch(setOfferTakeaway(false));
    }

    shippingOptions = shippingOptions.filter(
        shippingOption =>
            shippingOption.type !== 'Takeaway' &&
            shippingOption.type !== 'TakeawayOnly'
    );

    await dispatch(getShippingProvidersWithProducts());

    const removeCostIfCostMatchesSelectedProduct = (shippingOption, i) => {
        if (i > 1 || !shippingOption.productId || !shippingOption.cost) {
            return;
        }
        const shippingState = getSyiSlice(getState()).shipping;
        const variant = getVariant(shippingState, shippingOption);
        if (variant.price === shippingOption.cost) {
            shippingOption.cost = null;
        }
    };

    // Clone shipping options before mutating read only properies.
    shippingOptions = shippingOptions.map(shippingOption => ({
        ...shippingOption
    }));
    shippingOptions.forEach(transformPostNordParcelProductId);
    shippingOptions.forEach(removeCostIfCostMatchesSelectedProduct);

    dispatch({
        type: 'SET_SHIPPING_OPTIONS',
        payload: shippingOptions
    });

    const setShippingOptionVariantAfterDraft = isPrimary => {
        getPrimaryOrSecondaryProducts(
            getSyiSlice(getState()).shipping,
            isPrimary
        )
            .filter(({ productId }) => !!productId)
            .map(({ price, variants, productId }) => ({
                price,
                productVariant: variants.find(v => v.id === productId)
            }))
            .map(({ productVariant }) =>
                setShippingOptionVariant(isPrimary, productVariant)
            )
            .forEach(dispatch);
    };

    setShippingOptionVariantAfterDraft(true);
    setShippingOptionVariantAfterDraft(false);
};

const getShippingProvidersWithProducts = () => async (dispatch, getState) => {
    const { shipping } = getSyiSlice(getState());

    if (
        (shipping.primaryShippingProviders &&
            shipping.primaryShippingProviders.length > 0) ||
        shipping.isLoadingProvidersWithProducts === true
    ) {
        return;
    }

    dispatch({
        type: 'SET_SHIPPING_PROVIDERS_WITH_PRODUCTS_FETCHING'
    });

    const shippingProviders = await getShippingProviders();
    dispatch({
        type: 'SET_SHIPPING_PROVIDERS_WITH_PRODUCTS',
        payload: shippingProviders
    });
};

const setShippingFromcountry = payload => ({
    type: 'SET_SHIPPING_FROMCOUNTRY',
    payload
});

export default {
    calculateShipping,
    clearSuggestedShippingProducts,
    getShippingProvidersWithProducts,
    makeSecondaryShippingOptionPrimary,
    removeShippingOption,
    reset,
    resetSelected,
    setCalculatorDimensions,
    setOfferTakeaway,
    setOfferShipping,
    setSecondaryShippingOptionOpen,
    setShippingOptionCost,
    setShippingOptionsFromDraft,
    setShippingOptionVariant,
    setSuggestedShippingProducts,
    toggleShippingCalculator,
    toggleShippingOption,
    setShippingFromcountry
};
